import React from 'react';
import { Link } from 'react-router-dom';
import { blogData } from '../blogData'; // Import the blog data
import './BlogPage.css';

const BlogPage = () => {
  return (
    <>
      <section className="blog-page-section">
        <div className="container">
          <div className="blog-grid">
            {blogData.map((post) => (
              <Link to={`/blog/${post.slug}`} key={post.id} className="blog-card-link">
                <div className="blog-card">
                  {/* The image container has been removed */}
                  <div className="blog-card-content">
                    <p className="blog-card-category">{post.category}</p>
                    <h3 className="blog-card-title">{post.title}</h3>
                    <p className="blog-card-summary">{post.summary}</p>
                    <div className="blog-card-footer">
                      <span>{post.date}</span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogPage;
